module.exports = __webpack_public_path__ + "img/Logo DNCP.34fc48cb.svg";